module.exports = __webpack_public_path__ + "static/img/give2.379a459.png";


//////////////////
// WEBPACK FOOTER
// ./static/give2.png
// module id = pU1a
// module chunks = 0